"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SANITISABLE_UNICODE_CHARACTERS = exports.GSM_DOUBLE_CHARACTERS = exports.GSM_CHARSET = void 0;
/**
 *  All GSM characters found here: https://en.wikipedia.org/wiki/GSM_03.38
 * GSM characters supported by firetext can be found here: https://www.firetext.co.uk/docs/sms-marketing-glossary/gsm-character-set
 * This should be kept in sync with https://github.com/Accurx/rosemary/blob/trunk/src/Shared/accuRx.Shared/Classes/SmsSenderHelper.cs#L27
 */
exports.GSM_CHARSET = [
    "@",
    "Δ",
    "0",
    "¡",
    "P",
    "¿",
    "p",
    "£",
    "_",
    "!",
    "1",
    "A",
    "Q",
    "a",
    "q",
    "$",
    "Φ",
    '"',
    "2",
    "B",
    "R",
    "b",
    "r",
    "¥",
    "Γ",
    "#",
    "3",
    "C",
    "S",
    "c",
    "s",
    "è",
    "Λ",
    "¤",
    "4",
    "D",
    "T",
    "d",
    "t",
    "é",
    "Ω",
    "%",
    "5",
    "E",
    "U",
    "e",
    "u",
    "ù",
    "Π",
    "&",
    "6",
    "F",
    "V",
    "f",
    "v",
    "ì",
    "Ψ",
    "'",
    "7",
    "G",
    "W",
    "g",
    "w",
    "ò",
    "Σ",
    "(",
    "8",
    "H",
    "X",
    "h",
    "x",
    "Ç",
    "Θ",
    ")",
    "9",
    "I",
    "Y",
    "i",
    "y",
    "Ξ",
    "*",
    ":",
    "J",
    "Z",
    "j",
    "z",
    "Ø",
    "+",
    ";",
    "K",
    "Ä",
    "k",
    "ä",
    "ø",
    "Æ",
    ",",
    "<",
    "L",
    "Ö",
    "l",
    "ö",
    " ",
    "æ",
    "-",
    "=",
    "M",
    "Ñ",
    "m",
    "ñ",
    "Å",
    "ß",
    ".",
    ">",
    "N",
    "Ü",
    "n",
    "ü",
    "å",
    "É",
    "/",
    "?",
    "O",
    "§",
    "o",
    "à",
    "\n", // Wiki has as "LF" and "CR" - convert to char here
    "\r",
];
/**
 * These GSM characters count as 2 in a text message
 */
exports.GSM_DOUBLE_CHARACTERS = [
    "^",
    "{",
    "}",
    "[",
    "~",
    "]",
    "|",
    "€",
    "\\",
];
/**
 * Our server converts a small amount of unicode characters to equivalent GSM
 * characters in attempt to reduce the amount of times we need to switch to
 * unicode. The key of this map is the unicode string and the value is the
 * amount of GSM characters it gets converted to.
 *
 * Most are converted to a single character eg. '•' is converted to '-'
 * But some are converted to multiple characters eg. '…' is converted to '...'
 */
exports.SANITISABLE_UNICODE_CHARACTERS = {
    [String.fromCharCode(8203)]: 0, // zero-width-space gets deleted
    [String.fromCharCode(9)]: 1, // '\t' (tab) gets replaced with ' '
    [String.fromCharCode(96)]: 1, // '`' gets replaced with '''
    [String.fromCharCode(160)]: 1, // '\u00A0' (non-breaking whitespace) gets replaced with ' '
    [String.fromCharCode(8211)]: 1, // '–' gets replaced with '-'
    [String.fromCharCode(8212)]: 1, // '—' gets replaced with '-'
    [String.fromCharCode(8213)]: 1, // '―' gets replaced with '-'
    [String.fromCharCode(8216)]: 1, // '‘' gets replaced with '''
    [String.fromCharCode(8217)]: 1, // '’' gets replaced with '''
    [String.fromCharCode(8220)]: 1, // '“' gets replaced with '"'
    [String.fromCharCode(8221)]: 1, // '”' gets replaced with '"'
    [String.fromCharCode(8239)]: 1, // '\u202F' (narrow non-breaking whitespace) gets replaced with ' '
    [String.fromCharCode(8226)]: 1, // '•' gets replaced with '-'
    [String.fromCharCode(65279)]: 1, // '\uFEFF' (non-breaking whitespace) gets replaced with ' '
    [String.fromCharCode(8252)]: 2, // '‼' gets replaced with "!!"
    [String.fromCharCode(8230)]: 3, // '…' gets replaced with '...'
};
//# sourceMappingURL=messaging.constants.js.map